import React from 'react';
import { Input } from 'antd';
import { Form } from '..';
import commonMessage from '../../configs/commonMessage';
import Wrapper from './style';

const Index = () => {
  return (
    <Wrapper>
      <div className="font-subtitle2_medium black1">General Information</div>
      <div className="component_general_information_form">
        <div className="component_general_information_form_content">
          <div>
            <Form.Item
              label="Contact Name"
              name="name"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: commonMessage.required('Contact Name'),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </div>
          <div className="component_general_information_jobs_org">
            <Form.Item label="Job (Optional)" name="job">
              <Input />
            </Form.Item>
            <Form.Item
              label="Organization Name (Optional)"
              name="organization_name"
            >
              <Input />
            </Form.Item>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Index;
